import ODAS from '@/utils/api/odas';

const Team = {
  getTeams: (params) => {
    return ODAS.get(`/api/teams`, params);
  },
  addCollection: (teamId, collectionId) => {
    return ODAS.post('/api/teams/' + teamId + '/collections/' + collectionId, {});
  },
  removeCollection: (teamId, collectionId) => {
    return ODAS.delete('/api/teams/' + teamId + '/collections/' + collectionId);
  }
};

export default Team;
